import React, { useState } from "react";
import Footer from '../user/components/footer';
import Header from "../user/components/header";

const UnSubscribe = () => {

    const [selectedReason, setSelectedReason] = useState([]);


    return (
        <>
            <Header />
            <div className="sec_latestpd" style={{ marginTop: "150px" }}>
                <div className="container">
                    <div className="row mb-4 d-flex justify-content-center align-items-center">
                        <div className="col-md-8 text-center">
                            <h2>ranjanrakesh25@gmail.com</h2>
                            <h6><b>is subscribed to our mailing list(s).</b></h6>
                            <hr />
                        </div>
                        <div className="col-md-8 text-center">
                            <h2 style={{ color: 'red' }}><b>Unsubscribe from IndiGalleria's mailing list </b></h2>
                            <label>To help us improve our services, we would be grateful if you could tell us why?</label>
                                                        <select value={selectedReason} name="selectedReason" className="form-control form-select">
                                                            <option value="0">Please select reason</option>
                                                            <option value="1">Your emails is not relevent to me</option>
                                                            <option value="2">Your emails are too frequent to me</option>
                                                            <option value="3">I don't remember to signingup for this</option>
                                                            <option value="4">I no longer want to receive these emails</option>
                                                            <option value="5">The emails are spam and should be reported</option>
                                                            <option value="5">Others</option>
                                                        </select>
                          
                        </div>
                        <div className="col-md-8 text-center">
                        <button className="btn btn-primary w-50">Unsubscribe</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};
export default UnSubscribe;